//const baseURL = 'https://mercadoky13.free.nf';
//const baseURL = 'https://restaurante.encatalogo.com';
const baseURL = 'https://mercadoky13.com';
export default baseURL;
